import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchOrdersByCommercialOrder = (order, params = {}) => apiActionCreator({
  'endpoint': `/accessories/invoicing/commercial_order/${order}${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ORDERS_BY_COMMERCIAL_ORDER,
    ActionTypes.FETCHED_ORDERS_BY_COMMERCIAL_ORDER,
    [
      ActionTypes.FETCHED_ORDERS_BY_COMMERCIAL_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const createAccessoriesInvoice = (order, params = {}, data = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/accessories/invoicing/commercial_order/${order}`,
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_ACCESSORIES_INVOICE,
        [
          () => {
            dispatch(fetchOrdersByCommercialOrder(order, params));
            return {
              'type': ActionTypes.CREATED_ACCESSORIES_INVOICE,
            };
          },
          (response) => MessageActions.addMessageBoxInfo(response.data.message),
        ],
        [
          ActionTypes.CREATED_ACCESSORIES_INVOICE_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],

      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      data,
    }),
  );
};
